import useModal from "../../../../hooks/core/useModal";
import HistoryHeader from "../organisms/HistoryHeader";
import HistoryBody from "../organisms/HistoryBody";
import {useEffect} from "react";
import useHistory from "../../hooks/useHistory";

const History = () => {

  const customerId = sessionStorage.getItem("userCode");
  const { componentMount, subModalMount, closeModal, closeSubModal } = useModal();
  const {
    getConfigurationList, renderGroupedData,
    // selectedProductTab, setSelectedProductTab,
  } = useHistory();

  const modalProps = { componentMount, subModalMount, closeModal, closeSubModal };
  const props = {
    getConfigurationList, renderGroupedData,
    // selectedProductTab, setSelectedProductTab,
  };



  useEffect(() => {
    if (customerId) {
      getConfigurationList(customerId);
    }
  }, [customerId]);

  return (
    <div className={"design-history"}>
      <HistoryHeader/>
      <HistoryBody {...props} {...modalProps} />
    </div>
  )
}

export default History;
